const sections = {
    calendars: { key: 'calendars', name: 'Calendars', },
    timeGraph: { key: 'timeGraph', name: 'Time Graphs', },
    info: { key: 'info', name: 'Information', },
}

const pages = {


    financialCal: {
        key: 'financialCal',
        title: 'Financial Calendar',
        description: 'Financial Calendar Module',
        // fetchUrl: '/statistics/financial',
        fetchUrl: 'financialCalander',

        // addFetch: '/statistics/add',
        // removeUrl: '/statistics/remove',
        pageType: 'calendar',
        parent: 'calendars',
        showCalander: true,
        dateKeys: ['dueDate'],
        options: { noAddNew: true },
        indicators: {
            filter: [
                [{ key: "values.status" }, '==', '0']
            ],
            color: '#fff7f7',
            borderColor: '#fff0f0'
        },
        settings: { fetchFilter: { status: { $ne: 'done' } } },
        sort: { 'date': -1 },
        page: 'financialCal',
        image: 'https://images.unsplash.com/photo-1506784365847-bbad939e9335?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1948&q=80',

        headers: [

            { key: 'values.id', type: 'TextInput', showMain: true, information: { label: 'ID', disabled: true }, },
            { key: 'values.rentalId', type: 'TextInput', showMain: true, information: { label: 'Rental Id', disabled: false }, },
            // { title: 'Type', key: 'type', type: 'TextInput', showMain: true, settings: { disabled: false}, },
            { key: 'values.type', type: 'SelectInput', information: { label: 'Type', type: 'local', items: [{ title: "Invoice", value: 'Invoice' }, { title: 'Order', value: 'Order' }, { title: 'Refund', value: 'Refund' }] }, settings: { required: true }, showMain: true },

            // { title: 'Rental Id', type: 'select', key: 'rentalId', options: { type: 'api', fields: { value: '_id', title: 'values.rentalId' }, address: domain + '/values/getAll', filter: { page: 'rental' } }, settings: { required: true, url: '/values/getOneFilter', page: "rental", showInfo: true, disabled: true }, showMain: true },
            { key: 'values.status', type: 'SelectInput', information: { label: 'Status', type: 'local', items: [{ title: "{{lang}}pending", value: '0' }, { title: 'done', value: '1' }, { title: 'canceled', value: '-1' }] }, settings: { required: true }, showMain: true },
            // { title: 'Email Status', key: 'emailStatus', type: 'select', options: { type: 'local', items: [{ title: "pending", value: '0' }, { title: 'Sent', value: '1' }] }, settings: { required: true }, showMain: false, settings: { disabled: true }, },

            // { title: 'Title', type: 'TextInput', key: 'title', showMain: true },

            // { title: 'Description', key: 'description', type: 'TextInput', showMain: false, },

            { type: 'DateInput', key: 'values.dueDate', information: { label: 'Due Date', }, showMain: true },
            // { title: 'Payment Date', type: 'date', key: 'date', showMain: true, showMain: false, },

            // { title: 'Date From', type: 'date', key: 'dateFrom', showMain: false },
            // { title: 'Date To', type: 'date', key: 'dateTo', showMain: false },

            // { title: 'Calculator', key: 'calc', type: 'calculator', showMain: false, fullCol: true },
            { key: 'values.list', type: 'Calculator', information: { label: 'Total Price', }, showMain: true },




        ]
    },




    rentalCal: {
        key: 'rentalCal',

        title: 'Rentals Calendar',
        description: 'rental Calendar Module',
        // fetchUrl: '/statistics/rental',
        fetchUrl: 'rentalCalander',
        dateKeys: ['startDate', 'endDate'],

        // addFetch: '/statistics/add',
        // removeUrl: '/statistics/remove',
        pageType: 'calendar',
        parent: 'calendars',
        showCalander: true,

        options: { noAddNew: true },
        indicators: {
            filter: [
                [{ key: "values.status" }, '==', '0']
            ],
            color: '#fff7f7',
            borderColor: '#fff0f0'
        },
        settings: { fetchFilter: { status: { $ne: 'done' } } },
        sort: { 'date': -1 },
        page: 'rentalCal',
        image: 'https://images.unsplash.com/photo-1580227974546-fbd48825d991?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=934&q=80',
        headers: [

            { key: 'values.rentalId', type: 'TextInput', showMain: true, information: { label: 'Rental Id', disabled: true }, fullCol: true },

            { key: 'values.status', type: 'SelectInput', fullCol: true, information: { label: 'Status', type: 'local', default: '0', items: [{ title: "Reserved", value: '0' }, { title: "Waiting For Delivery", value: '1' }, { title: 'In rental', value: '2' }, { title: 'Finished', value: '3' }, { title: 'Cancelled By Requester', value: '10' }, { title: 'Cancelled By Ownner', value: '11' }] }, settings: { required: true }, showMain: true },


            { key: 'values.requester.company', type: 'TextInput', showMain: true, information: { label: 'User', disabled: true }, fullCol: true, hideInList: true },
            { key: 'values.tempCreator.company', type: 'TextInput', showMain: true, information: { label: 'Owner', disabled: true }, fullCol: true, hideInList: true },
            { key: 'values.tempCategory.name', type: 'TextInput', showMain: true, information: { label: 'Category', disabled: true }, fullCol: true, hideInList: true },


            { version: 1, dontShowHeader: true, col: '6', key: 'values.paymentStatus', type: 'NewStatusIndicator', thirdCol: true, information: { label: 'Payments', type: 'local', default: '0', relatedKey: 'values.invoices', valueType: "Invoice", items: [{ title: "{{lang}}Pending", value: '0', color: '#eee' }, { title: 'Done', value: '1', color: '#00C9A7' }, { title: 'Need Payment', value: '2', color: '#FF7D9D' }, { title: 'EXPIRED', value: '3', color: '#FF7D9D' }] }, showMain: true },
            { version: 1, dontShowHeader: true, col: '6', key: 'values.transactionStatus', type: 'NewStatusIndicator', thirdCol: true, information: { label: 'Transactions', type: 'local', default: '0', relatedKey: 'values.invoices', valueType: "Order", items: [{ title: "{{lang}}Pending", value: '0', color: '#eee' }, { title: 'Done', value: '1', color: '#00C9A7' }, { title: 'Need Payment', value: '2', color: '#FF7D9D' }] }, showMain: true },
            { version: 1, dontShowHeader: true, col: '6', key: 'values.guaranteeStatus', type: 'NewStatusIndicator', thirdCol: true, information: { label: 'Refunds', type: 'local', default: '0', relatedKey: 'values.invoices', valueType: "Refund", items: [{ title: "{{lang}}Pending", value: '0', color: '#eee' }, { title: 'Done', value: '1', color: '#00C9A7' }, { title: 'Need Payment', value: '2', color: '#FF7D9D' }] }, showMain: true },


            { key: 'values.startDate', type: 'DateInput', information: { label: 'Start date', }, showMain: true, },
            { key: 'values.endDate', type: 'DateInput', information: { label: 'End Date', }, showMain: true, },


        ]
    },




    financialReport: {
        key: 'financialReport',
        title: 'Financial Report',
        description: 'Financial Report Module',
        fetchUrl: 'financialReport',
        fetchReport: 'financialReport',


        pageType: 'timeGraph',
        showDatePicker: true,
        // showChart: true,
        // showDatePicker: true,
        showTimeChart: true,
        extraSelect: [{ value: 'total', title: 'total' }, { value: 'discount', title: 'discount' }, { value: 'tax', title: 'GST' }],
        extraSelectDefault: 'total',
        // extraTitle:'',
        dateKeys: ['dueDate'],
        options: { noAddNew: true },
        indicators: {
            filter: [
                [{ key: "values.status" }, '==', '0']
            ],
            color: '#fff7f7',
            borderColor: '#fff0f0'
        },
        settings: { fetchFilter: { status: { $ne: 'done' } } },
        sort: { 'date': -1 },
        page: 'financialReport',
        image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80',
        parent: 'timeGraph',
        headers: [


        ]
    },



    listingReport: {
        key: 'listingReport',
        title: 'Listing Report',
        description: 'Listing Report Module',
        fetchUrl: 'listingReport',
        fetchReport: 'listingReport',

        pageType: 'timeGraph',
        showDatePicker: true,
        showTimeChart: true,
        parent: 'timeGraph',

        dateKeys: ['dueDate'],
        options: { noAddNew: true },
        settings: { fetchFilter: { status: { $ne: 'done' } } },
        sort: { 'date': -1 },
        page: 'listingReport',
        image: 'https://images.unsplash.com/photo-1543286386-2e659306cd6c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1950&q=80',


    },




    rentalsReport: {
        key: 'rentalsReport',
        title: 'Rentals Report',
        description: 'Rentals Report Module',
        fetchUrl: 'rentalsReport',
        fetchReport: 'rentalsReport',


        pageType: 'timeGraph',
        showDatePicker: true,
        showTimeChart: true,

        dateKeys: ['dueDate'],
        options: { noAddNew: true },
        settings: { fetchFilter: { status: { $ne: 'done' } } },
        sort: { 'date': -1 },
        page: 'rentalsReport',
        image: 'https://images.unsplash.com/photo-1518607692857-bff9babd9d40?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1567&q=80',
        parent: 'timeGraph',

    },





    usersReport: {
        key: 'usersReport',
        title: 'Users Report',
        description: 'Users Report Module',
        fetchUrl: 'usersReport',
        fetchReport: 'usersReport',

        pageType: 'timeGraph',
        showDatePicker: true,
        showTimeChart: true,
        parent: 'timeGraph',

        dateKeys: ['dueDate'],
        options: { noAddNew: true },
        settings: { fetchFilter: { status: { $ne: 'done' } } },
        sort: { 'date': -1 },
        page: 'usersReport',
        image: 'https://images.unsplash.com/photo-1581291518857-4e27b48ff24e?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80',


    },


    partnersReport: {
        key: 'partnersReport',
        title: 'Partners Report',
        description: 'Partners Report Module',
        fetchUrl: 'partnersReport',
        fetchReport: 'partnersReport',

        pageType: 'timeGraph',
        parent: 'timeGraph',
        showDatePicker: true,
        showTimeChart: true,

        dateKeys: ['dueDate'],
        options: { noAddNew: true },
        settings: { fetchFilter: { status: { $ne: 'done' } } },
        sort: { 'date': -1 },
        page: 'partnersReport',
        image: 'https://images.unsplash.com/photo-1581291518570-03a26006fb21?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2700&q=80',


    },






    equipmentsReport: {
        key: 'equipmentsReport',
        title: 'Equipments Report',
        description: 'Equipments Report Module',
        fetchUrl: 'equipmentsReport',
        fetchReport: 'equipmentsReport',

        pageType: 'info',
        parent: 'info',
        showDatePicker: false,
        showHorizontalChart: true,
        extraSelect: [{ value: 'partners', title: 'partners' }, { value: 'categories', title: 'categories' }],
        extraSelectDefault: 'partners',

        dateKeys: ['dueDate'],
        options: { noAddNew: true },
        settings: { fetchFilter: { status: { $ne: 'done' } } },
        sort: { 'date': -1 },
        page: 'equipmentsReport',
        image: 'https://images.unsplash.com/photo-1543286386-713bdd548da4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1950&q=80',


    },




    salesReport: {
        key: 'salesReport',
        title: 'Sales Report (by unit)',
        description: 'Sales Report Module (count by unit)',
        fetchUrl: 'salesReport',
        fetchReport: 'salesReport',

        pageType: 'info',
        parent: 'info',
        showDatePicker: false,
        showHorizontalChart: true,
        extraSelect: [{ value: 'partners', title: 'partners' }, { value: 'users', title: 'users' }, { value: 'categories', title: 'categories' }],
        extraSelectDefault: 'partners',

        dateKeys: ['dueDate'],
        options: { noAddNew: true },
        settings: { fetchFilter: { status: { $ne: 'done' } } },
        sort: { 'date': -1 },
        page: 'salesReport',
        image: 'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1955&q=80',

    },



    salesReportByPrice: {
        key: 'salesReportByPrice',
        title: 'Sales Report (by price)',
        description: 'Sales Report Module (count by price)',
        fetchUrl: 'salesReportByPrice',
        fetchReport: 'salesReportByPrice',

        pageType: 'info',
        parent: 'info',
        showDatePicker: false,
        showHorizontalChart: true,
        extraSelect: [{ value: 'partners', title: 'partners' }, { value: 'users', title: 'users' }, { value: 'categories', title: 'categories' }],
        extraSelectDefault: 'partners',

        dateKeys: ['dueDate'],
        options: { noAddNew: true },
        settings: { fetchFilter: { status: { $ne: 'done' } } },
        sort: { 'date': -1 },
        page: 'salesReportByPrice',
        image: 'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1955&q=80',


    },











}



// const modules = Object.values(StatisticsData)


export { pages, sections };